/* eslint-disable react/no-unescaped-entities */
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Wordmark } from "../components/brand/Brand";
import Footer from "../components/sections/Footer";

export default function LegalPage({ title, updated, blocks, testId }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-white min-h-screen flex flex-col" data-testid={testId}>
      <header className="bg-diallo-red">
        <div className="mx-auto max-w-4xl px-5 md:px-8 h-[68px] flex items-center justify-between">
          <Link to="/" data-testid="legal-logo-home"><Wordmark variant="white" className="h-7" /></Link>
          <Link
            to="/"
            data-testid="legal-back-home"
            className="inline-flex items-center gap-2 text-white/90 text-sm font-medium hover:text-white transition-colors"
          >
            <ArrowLeft size={18} /> Retour à l'accueil
          </Link>
        </div>
      </header>

      <main className="flex-1">
        <div className="mx-auto max-w-4xl px-5 md:px-8 py-16 md:py-24">
          <h1 className="font-display font-extrabold text-4xl md:text-5xl text-diallo-charcoal">{title}</h1>
          {updated && <p className="mt-3 text-diallo-ink/50">Dernière mise à jour : {updated}</p>}

          <div className="mt-10 space-y-10">
            {blocks.map((b, i) => (
              <section key={i}>
                <h2 className="font-display font-bold text-2xl text-diallo-charcoal">{b.heading}</h2>
                {b.paragraphs.map((p, j) => (
                  <p key={j} className="mt-3 text-diallo-ink/80 leading-relaxed">{p}</p>
                ))}
              </section>
            ))}
          </div>

          <div className="mt-14 rounded-2xl bg-diallo-sand p-6 text-diallo-ink/70">
            Contenu type à compléter par Océana Groupe. Ce document est fourni à titre indicatif.
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
